import { Component, Input, OnInit, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { GraphDataEthnicity, MyopeProgressionType, SingleMyopRiskAt18Result } from '../../backend-response-models/calc-enums.helper';
import { Dataset } from '../../shared/shared-enums/enum-helper';
import { CalculationResults, MyopeProgressionResults, SingleMyopeResults } from '../../backend-response-models/calc-interfaces.helper';
import { TranslatePipe } from '../../languages/translate.pipe';
import { COMMON_IMPORTS } from '../../common-imports';
import { ChartModule } from 'primeng/chart';
import { DropdownChangeEvent, DropdownModule } from 'primeng/dropdown';
import { PanelModule } from 'primeng/panel';
import { blackColorTL, greenColorTL, redColorTL, whiteColorTL, yellowColorTL } from '../../helpers/ui.helper';
import { ChipModule } from 'primeng/chip';
import { MyopiaProgressionEimRetestComponent } from '../myopia-progression-eim-retest/myopia-progression-eim-retest.component';
import { StandardProgressionComponent } from '../../standard-progression/standard-progression.component';

@Component({
  selector: 'app-myopia-progression',
  standalone: true,
  imports: [
    ...COMMON_IMPORTS,
    PanelModule,
    DropdownModule,
    ChartModule,
    ChipModule,
    MyopiaProgressionEimRetestComponent,
    StandardProgressionComponent,
  ],
  templateUrl: './myopia-progression.component.html',
  styleUrl: './myopia-progression.component.css',
})
export class MyopiaProgressionComponent implements OnChanges, OnInit {
  MyopeProgressionType = MyopeProgressionType;
  @Input({ required: true })
  myopeProgressionResults?: MyopeProgressionResults;

  @Input()
  personalization?: string;

  @Input({ required: true })
  calculationResults!: CalculationResults;

  @Output()
  ethnicityChanged = new EventEmitter<GraphDataEthnicity>();

  @Input({ required: true })
  ethnicity?: GraphDataEthnicity;

  public progressionTypeLabel: string = 'NONE';
  public explanationLabel: string = 'NONE';
  public serLabel: string = 'NONE';
  public alLabel: string = 'NONE';
  public retestPeriodMonths = 18;

  constructor(private readonly translatePipe: TranslatePipe) {}

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  ngOnChanges(changes: SimpleChanges): void {
    this.refreshAll();
  }

  ngOnInit(): void {
    this.refreshAll();
  }

  onEthnicityChange(newEthnicity: GraphDataEthnicity): void {
    this.ethnicityChanged.emit(newEthnicity);
  }

  refreshAll() {
    this.retestPeriodMonths = this.myopeProgressionResults?.retestPeriodMonths ?? 18;
    const type = this.myopeProgressionResults?.myopeProgressionStat.myopeProgressionType;
    const typeTranlslationKey = type === MyopeProgressionType.REAL ? 'CALCULATED' : 'EXTRAPOLATED';
    this.progressionTypeLabel = this.translatePipe.transform(typeTranlslationKey);

    const explanationTranslationKey =
      type === MyopeProgressionType.REAL ? 'MYOPIA_PROGRESSION_EXPLAINATION_MEASURED' : 'MYOPIA_PROGRESSION_EXPLAINATION_PROJECTED';
    this.explanationLabel = this.translatePipe.transform(explanationTranslationKey);

    const year = this.translatePipe.transform('YEAR');
    this.serLabel = this.myopeProgressionResults!.myopeProgressionStat!.serPerYear!.toFixed(2) + `D / ${year}`;

    const hasAxialLength =
      this.myopeProgressionResults?.myopeProgressionStat.axialLengthPerYear !== undefined &&
      this.myopeProgressionResults?.myopeProgressionStat.axialLengthPerYear !== null;

    if (hasAxialLength) {
      this.alLabel = (this.myopeProgressionResults?.myopeProgressionStat.axialLengthPerYear ?? 0).toFixed(2) + `mm / ${year}`;
    } else {
      this.alLabel = '----';
    }
  }
}
